import { render, staticRenderFns } from "./BlujayBcaTransactionIndex.vue?vue&type=template&id=35bfd47e&scoped=true&"
import script from "./BlujayBcaTransactionIndex.vue?vue&type=script&lang=js&"
export * from "./BlujayBcaTransactionIndex.vue?vue&type=script&lang=js&"
import style0 from "./BlujayBcaTransactionIndex.vue?vue&type=style&index=0&id=35bfd47e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bfd47e",
  null
  
)

export default component.exports